export interface CrudState {
  //-------commonFlags
  isMenuOpen: boolean;
  isRightMenuOpen: boolean;
  notification: any;
  dialog: any;
  isLoader: boolean;

  //-------flags
  isSubmit: boolean;
  isBasicSubmit: boolean;
  isIndustrySubmit: boolean;
  isCompanySubmit: boolean;
  isLegalSubmit: boolean;
  isTaxSubmit: boolean;

  //-------pickList
  businessTypeList: any;
  organizationTypeList: any;
  countryList: any;
  industrySectorList: any;
  dataComplianceList: any;
  companySizeList: any;
  registrationAuthorityList: any;
  taxRegimeTypeList: any;
  taxFillingFrequencyList: any;
  sectorList: any;
  segmentTypeList: any;
  incorporationTypeList: any;
  localizationList: any;
  organizationContactPointType: any;
  catalogList: any;
  productSeriesList: any;
  classificationsList: any;
  productAssociationList: any;
  contentGroupList: any;
  statuesList: any;
  languageList: any;
  brandsList: any;
  organizationList: any;
  personTypeList: any;
  genderList: any;
  nationalityList: any;
  experienceLevel: any;
  skillTypeList: any;
  departmentList: any;
  relationList: any;
  designationList: any;
  maritalStatusList: any;
  employmentTypeList: any;
  employeeList: any;
  salutationList: any;
  attributeTypeList: any;
  attributeGroupList: any;
  attributeTabList: any;
  unitOfMeasurementList: any;
  categoryList: any;
  postingTypeList: any;
  claimToIdList: any;
  taxExemptionList: any;
  hnsCodeList: any;
  priceTypeList: any;
  sacLookupList: any;
  equipmentList: any;
  servicesList: any;
  modelList: any;
  groupTypeList: any;
  customerTypeList: any;
  getSmallMasterList: any;
  chargeTypeList: any;
  roundOffList: any;
  authorityList: any;
  componentTypeList: any;
  calculationMethodList: any;
  componentRangeFromToList: any;
  timeZoneList: any;
  inventoryCountCyclicFrequencyList: any;
  warehouseList: any;
  stockTypeList: any;
  fiscalPeriodList: any;
  fiscalYearList: any;
  lockReasonList: any;
  locationTypesList: any;
  HsnCodeList: any;
  materialList: any;

  //------ organization
  organizationPaging: any;
  organization: any;
  getRootOrganization: any;

  //------ channelManagement
  getChannelByOrganizationId: any;
  channelMapping: any;
  getBranchList: any;
  channelTypeList: any;

  //------- common
  localeForPriceList: any;
  currencyList: any;

  //------- organizationSetting
  organizationFeatureList: any;
  settingByOrganizationId: any;

  //-------organization Contact point
  crateContactPoint: any;
  contactPointPaging: any;
  contactPointById: any;

  //----------------Product Classifications
  crateClassifications: any;
  classificationsPaging: any;
  classificationGetById: any;
  classIficationsById: any;
  productClassificationsPaging: any;
  productClassificationsUpsertMany: any;

  //----------Address Details
  addressPaging: any;
  createAddress: any;
  updateAddress: any;
  getAddress: any;

  //-----organization Owner
  organizationOwnersPaging: any;
  organizationOwnerGet: any;

  //-----organization Founder
  organizationFounderPaging: any;

  //-----organization Sponsors
  organizationSponsorsPaging: any;

  //---------------- product catalog
  createCatalog: any;
  catalogPaging: any;
  catalogGetById: any;

  //-------------product product Series
  createProductSeries: any;
  productSeriesPaging: any;
  productSeriesGetById: any;

  //------------product Attribute
  attributePaging: any;
  getChildAttribute: any;
  getParentAttribute: any;
  attributeAllPaging: any;
  productAttributeValuesPaging: any;

  //-------------product Attribute tab
  attributeTabPaging: any;
  createAttributeTab: any;
  attributeTabGetById: any;

  //-------------product Attribute group
  attributeGroupPaging: any;
  createAttributeGroup: any;
  attributeGroupGetById: any;
  attributeByGroupIdPaging: any;
  attributesByIdPaging: any;

  //-------------product
  createProduct: any;
  productPaging: any;
  productList: any;
  productPagingById: any;
  ProductAttributeValuePaging: any;
  ProductCategoryPaging: any;
  ProductAssociationPaging: any;
  ProductContentsPaging: any;
  productChannelPaging: any;

  //------- designation
  designationPaging: any;
  designation: any;

  //-------Employee
  employeePaging: any;

  //------content group
  createContentGroup: any;
  contactPaging: any;
  contentGroup: any;

  //------------content
  createContent: any;
  contentPaging: any;
  contentGetById: any;

  //------------Associations
  createProductAssociation: any;
  associationPaging: any;
  associationGetById: any;

  //------------ChartOfAccountType
  subAccountTypes: any;
  accountTypeGetById: any;

  //------------ChartOfAccount
  accountPaging: any;
  parentAccountByTypeList: any;

  //-----------language
  languageUpdate: any;
  languagesPaging: any;

  //-----------SkillSet
  createSkillSet: any;
  skillSetPaging: any;

  //------------OrganizationBrand
  organizationBrandPaging: any;

  //------------OrganizationOpeningHours
  organizationOpeningHoursPaging: any;

  //------------Organization department
  OrganizationDepartmentPaging: any;

  //------------Service Type
  serviceTypePaging: any;
  serviceTypeAssociationPaging: any;

  //------------Channel Management
  channelPaging: any;
  channelGetById: any;

  //------------ProductType
  productTypeList: any;

  //------categories
  categoryPaging: any;
  categoryGetById: any;

  //----categories by details
  categoryDetailsPaging: any;
  serviceTypeList: any;

  //............Service Contract
  serviceContractPaging: any;
  creteServiceContract: any;

  //..............Service paging
  servicePaging: any;
  serviceManHourPaging: any;
  serviceAssociationPaging: any;

  //.............Channel Product
  channelProductPaging: any;

  //--=========catalog details
  catalogDetailsPaging: any;

  //------------Organization Group
  organizationGroupPaging: any;
  organizationGroupGetById: any;

  //------ Organization Group Details
  organizationGroupDetailsPaging: any;

  // product category
  productCategoryPaging: any;

  //------------Product Group
  productGroupPaging: any;
  productGroupGetById: any;

  //------ Product Group Details
  productGroupDetailsPaging: any;

  //------------Service Group
  serviceGroupPaging: any;
  serviceGroupGetById: any;

  //------ Service Group Details
  serviceGroupDetailsPaging: any;

  //------Charge Of Authority
  chargeOfAuthorityPagingList: any;
  chargeOfAuthorityConfigurationPagingList: any;

  //------------Customer
  customerPaging: any;
  customerGetById: any;

  //------------Brands
  brandGetById: any;
  brandPaging: any;

  //------------warehousePaging
  warehousePaging: any;

  //----------Zone
  zonePaging: any;

  //---------warehouseGroupPaging
  warehouseGroupPaging: any;

  //------------Inventory Business Setup
  inventoryBusinessSetupPaging: any;

  //------------LockReasons
  lockReasonsPaging: any;

  //------------Stock Type
  stockTypePaging: any;

  //-----------shipping Method
  shippingMethodPaging: any;

  //-----------inventoryCountCyclicFrequency
  inventoryCountCyclicFrequencyPaging: any;

  //-----------warehouseAddress
  warehouseAddressPaging: any;
  //------------Location Types
  locationTypesPaging: any;

  //------------Product Stock Types
  productStockTypesPaging: any;

  //------------Locations
  locationsPaging: any;

  status: "idle" | "loading" | "failed";
  [key: string]: any;
}

export const initialState: CrudState = {
  //-------commonFlags
  isMenuOpen: false,
  isRightMenuOpen: false,
  notification: {
    type: "error",
    message: "",
    isOpen: false,
  },

  dialog: {
    title: {},
    subTitle: {},
    onConfirm: {},
    isOpen: false,
    item: null,
  },

  isLoader: false,
  activeRoutes: [],

  //-------flags
  isSubmit: false,
  isBasicSubmit: false,
  isIndustrySubmit: false,
  isCompanySubmit: false,
  isLegalSubmit: false,
  isTaxSubmit: false,

  //-------pickList
  businessTypeList: [],
  organizationTypeList: [],
  countryList: [],
  industrySectorList: [],
  dataComplianceList: [],
  companySizeList: [],
  registrationAuthorityList: [],
  taxRegimeTypeList: [],
  taxFillingFrequencyList: [],
  sectorList: [],
  segmentTypeList: [],
  incorporationTypeList: [],
  localizationList: [],
  organizationContactPointType: [],
  catalogList: [],
  productSeriesList: [],
  classificationsList: [],
  productAssociationList: [],
  contentGroupList: [],
  statuesList: [],
  languageList: [],
  brandsList: [],
  organizationList: [],
  accountTypeList: [],
  personTypeList: [],
  genderList: [],
  nationalityList: [],
  experienceLevel: [],
  skillTypeList: [],
  departmentList: [],
  relationList: [],
  designationList: [],
  maritalStatusList: [],
  employmentTypeList: [],
  employeeList: [],
  salutationList: [],
  attributeTypeList: [],
  attributeGroupList: [],
  attributeTabList: [],
  unitOfMeasurementList: [],
  categoryList: [],
  postingTypeList: [],
  claimToIdList: [],
  taxExemptionList: [],
  hnsCodeList: [],
  priceTypeList: [],
  sacLookupList: [],
  equipmentList: [],
  servicesList: [],
  modelList: [],
  groupTypeList: [],
  customerTypeList: [],
  getSmallMasterList: [],
  chargeTypeList: [],
  roundOffList: [],
  authorityList: [],
  componentTypeList: [],
  calculationMethodList: [],
  componentRangeFromToList: [],
  timeZoneList: [],
  inventoryCountCyclicFrequencyList: [],
  warehouseList: [],
  stockTypeList: [],
  fiscalPeriodList: [],
  fiscalYearList: [],
  lockReasonList: [],
  locationTypesList: [],
  HsnCodeList: [],
  materialList: [],

  //------ organization
  organizationPaging: [],
  organization: {},
  getRootOrganization: {},

  //------ channelManagement
  getChannelByOrganizationId: [],
  channelMapping: [],
  getBranchList: [],
  channelTypeList: [],

  //------ common
  localeForPriceList: [],
  currencyList: [],

  //------- organizationSetting
  organizationFeatureList: [],
  settingByOrganizationId: {},

  //-------organization currency
  organizationCurrencyPaging: [],

  //-------organization ContactPoint
  crateContactPoint: [],
  contactPointPaging: [],
  contactPointById: [],

  //----------------Product Classifications
  crateClassifications: [],
  classificationsPaging: [],
  classificationGetById: [],
  classIficationsById: [],
  productClassificationsPaging: [],
  productClassificationsUpsertMany: [],

  //--------Address Details
  addressPaging: {},
  createAddress: {},
  updateAddress: {},
  getAddress: {},

  //-----organization Owner
  organizationOwnersPaging: [],
  organizationOwnerGet: {},

  //-----organization Founder
  organizationFounderPaging: [],

  //-----organization Sponsors
  organizationSponsorsPaging: [],

  //---------------- product catalog
  createCatalog: [],
  catalogPaging: [],
  catalogGetById: {},

  //-------------product product Series
  createProductSeries: [],
  productSeriesPaging: [],
  productSeriesGetById: [],

  //------------product Attribute
  attributePaging: [],
  getChildAttribute: [],
  getParentAttribute: [],
  attributeAllPaging: [],
  productAttributeValuesPaging: [],

  //-------------product Attribute tab
  attributeTabPaging: [],
  createAttributeTab: [],
  attributeTabGetById: [],

  //-------------product Attribute group
  attributeGroupPaging: [],
  createAttributeGroup: [],
  attributeGroupGetById: [],
  attributeByGroupIdPaging: [],
  attributesByIdPaging: [],

  //-------------product
  createProduct: {},
  productPaging: [],
  productList: [],
  productPagingById: [],
  ProductAttributeValuePaging: [],
  ProductCategoryPaging: [],
  ProductAssociationPaging: [],
  ProductContentsPaging: [],
  productChannelPaging: [],

  //------- designation
  designationPaging: [],
  designation: {},

  //--------Employee
  employeePaging: [],

  //------content group
  createContentGroup: [],
  contactPaging: [],
  contentGroup: [],

  //------------content
  createContent: [],
  contentPaging: [],
  contentGetById: [],

  //------------Associations
  createProductAssociation: [],
  associationPaging: [],
  associationGetById: {},

  //------------ChartOfAccountType
  subAccountTypes: [],
  accountTypeGetById: {},

  //------------ChartOfAccount
  accountPaging: [],
  parentAccountByTypeList: [],

  //-----------language
  languageUpdate: [],
  languagesPaging: [],

  //-----------SkillSet
  createSkillSet: [],
  skillSetPaging: [],
  //------------OrganizationBrand
  organizationBrandPaging: [],

  //------------OrganizationOpeningHours
  organizationOpeningHoursPaging: [],

  //------------Organization department
  OrganizationDepartmentPaging: [],

  //------categories
  categoryPaging: [],
  categoryGetById: [],

  //----categories by details
  categoryDetailsPaging: [],
  //------------Service Type
  serviceTypePaging: [],
  serviceTypeAssociationPaging: [],

  //------------Channel Management
  channelPaging: [],
  channelGetById: {},

  //------------ProductType
  productTypeList: [],
  serviceTypeList: [],

  //------------Service Contract
  serviceContractPaging: [],
  creteServiceContract: [],

  //.............Services
  servicePaging: [],
  serviceManHourPaging: [],
  serviceAssociationPaging: [],

  //.............Channel Product
  channelProductPaging: [],

  //--=========catalog details
  catalogDetailsPaging: [],

  //------------Organization Group
  organizationGroupPaging: [],
  organizationGroupGetById: {},

  //------ Organization Group Details
  organizationGroupDetailsPaging: [],

  // product category
  productCategoryPaging: [],

  //------------Product Group
  productGroupPaging: [],
  productGroupGetById: [],

  //------ Product Group Details
  productGroupDetailsPaging: [],

  //------------Service Group
  serviceGroupPaging: [],
  serviceGroupGetById: [],

  //------ Service Group Details
  serviceGroupDetailsPaging: [],

  //------------Customer
  customerPaging: [],
  customerGetById: [],

  //-----userManagement
  //------user
  userPaging: [],
  creteUser: [],
  getUserById: [],
  updateUsers: [],
  SalutationList: [],

  //------------Brands
  brandGetById: {},
  brandPaging: [],

  //--Role
  RolePaging: [],
  getRoleById: [],
  appLicationList: [],
  createRole: [],
  UpdateRole: [],
  pagingRoleFeatures: [],
  //------------warehousePaging
  warehousePaging: [],

  //----------Zone
  zonePaging: [],

  //------warehouseGroupPaging
  warehouseGroupPaging: [],
  //------------Inventory
  inventoryBusinessSetupPaging: [],

  //---role mapping
  getRoleMappingPaging: [],
  getRoleMappingPagingAll: [],
  getRoleApplicationMappingPaging: [],
  RoleApplicationMappingPagingAll: [],
  getModules: [],
  pagingRoleModules: [],
  roleFeaturePaging: [],
  //--modules
  modulesPaging: [],
  creteModules: [],
  modulesGetById: [],
  updateModules: [],
  modulesList: [],

  //--menu URL
  menuPaging: [],
  creteMenu: [],
  menuGetById: [],
  updateMenu: [],
  menuList: [],

  //-features URL
  featurePaging: [],
  featureGetById: [],
  updateFeature: [],
  creteFeature: [],

  //------------Inventory
  inventoryPaging: [],

  //------------LockReasons
  lockReasonsPaging: [],

  //-----modules user mapping
  modulesUserMappingPaging: [],

  //--- menu  mapping
  featureMenuPaging: [],
  roleMenuPaging: [],
  roleMenuPagingAll: [],
  createRoleMenuAPI: [],

  //--feature mapping
  featureRolePaging: [],
  featureRolePagingAll: [],
  moduleList: [],
  featureRoleList: [],
  featureAccessPagingByFeatureId: [],

  //--feature Access
  featureAccessPaging: [],
  featureList: [],
  featureAccessCreate: [],
  featureAccessGetById: [],
  featureAccessUpdate: [],

  //------------Stock Type
  stockTypePaging: [],

  //-----------shipping Method
  shippingMethodPaging: [],

  //-----------inventoryCountCyclicFrequency
  inventoryCountCyclicFrequencyPaging: [],

  //-----------warehouseAddress
  warehouseAddressPaging: [],
  //------------Location Types
  locationTypesPaging: [],

  //------------Product Stock Types
  productStockTypesPaging: [],

  //------------Locations
  locationsPaging: [],

  status: "idle",
  chargeOfAuthorityPagingList: undefined,
  chargeOfAuthorityConfigurationPagingList: undefined,
};

export interface CreateInterface {
  key: string;
  url: string;
  request: any;
}

export interface ListInterface {
  key: string;
  url: string;
  request: any;
}

export interface GetInterface {
  key: string;
  url: string;
  params?: any;
}

export interface PagingInterface {
  key: string;
  url: string;
  params: any;
}

export interface UpdateInterface {
  url: string;
  request: any;
  key: string;
}

export interface DeleteInterface {
  url: string;
  request: any;
}

export interface BodyAndParamsInterface {
  key: string;
  url: string;
  params: any;
  request: any;
}
